// translations/it.js - Italian translations for Operator App
export const it = {
  // Dashboard Page
  "dashboard.title": "Dashboard Audit QA",
  "dashboard.welcome": "Benvenuto nelle Operazioni di Garanzia Qualità",
  "dashboard.subtitle": "Sistema Digitale di Audit Qualità",
  "dashboard.select_form": "Seleziona Modulo di Audit",
  "dashboard.recent_audits": "Audit Recenti",
  "dashboard.statistics": "Statistiche",
  "dashboard.start_new_audit": "Inizia Nuovo Audit",
  "dashboard.enter_serial": "INSERISCI il Numero di Serie",
  "dashboard.scan_serial": "SCANSIONA Numero di Serie Chiller",
  "dashboard.show_debug": "Mostra Info Debug",
  "dashboard.hide_debug": "Nascondi Info Debug",
  "dashboard.debug_info": "Informazioni Debug",
  "dashboard.wip_audit": "Audit in Lavorazione",
  "dashboard.avg_time_per_audit": "Tempo Medio per Audit",
  "dashboard.hrs": "Ore",
  "dashboard.audits_up_to_date": "Audit Aggiornati",
  "dashboard.average_score": "Punteggio Medio",
  "dashboard.completed_audits": "Audit Completati",
  "dashboard.draft_audits": "Audit in Lavorazione",
  "dashboard.table_sn": "N/S",
  "dashboard.table_chiller_sn": "S/N CHILLER",
  "dashboard.table_score": "PUNTEGGIO",
  "dashboard.table_ov": "OV #",
  "dashboard.table_model": "MODELLO #",
  "dashboard.table_pl": "LP #",
  "dashboard.table_date_time": "DATA E ORA",
  "dashboard.table_action": "AZIONE",
  "dashboard.view_audit_details": "Visualizza dettagli audit",
  "dashboard.showing_audits": "Mostrando",
  "dashboard.of_audits": "di",
  "dashboard.audits": "audit",
  "dashboard.previous": "Precedente",
  "dashboard.next": "Successivo",
  "dashboard.no_completed_audits": "Nessun audit completato disponibile",
  "dashboard.completed_audits_appear": "Gli audit completati appariranno qui una volta disponibili",
  "dashboard.draft": "BOZZA",
  "dashboard.resume": "Riprendi",
  "dashboard.showing_drafts": "Mostrando",
  "dashboard.of_drafts": "di",
  "dashboard.drafts": "bozze",
  "dashboard.no_draft_audits": "Nessuna bozza di audit in corso",

  // Navigation
  "nav.dashboard": "Dashboard",
  "nav.audit": "Audit",
  "nav.categories": "Categorie",
  "nav.control_items": "Elementi di Controllo",
  "nav.checklist": "Lista di Controllo",
  "nav.summary": "Riepilogo",

  // Common Buttons
  "btn.next": "Avanti",
  "btn.back": "Indietro",
  "btn.previous": "Precedente",
  "btn.dashboard": "Dashboard",
  "btn.save": "Salva",
  "btn.cancel": "Annulla",
  "btn.complete": "Completa",
  "btn.continue": "Continua",
  "btn.start": "Inizia",
  "btn.finish": "Termina",
  "btn.submit": "Invia",
  "btn.close": "Chiudi",
  "btn.edit": "Modifica",
  "btn.view": "Visualizza",
  "btn.download": "Scarica",
  "btn.export": "Esporta",

  // Status Labels
  "status.completed": "Completato",
  "status.draft": "Modalità bozza",
  "status.not_started": "Non ancora iniziato",
  "status.in_progress": "In Corso",
  "status.pending": "In Attesa",
  "status.label": "Stato",
  "status.published": "Pubblicato",

  // Common Messages
  "msg.loading": "Caricamento...",
  "msg.saving": "Salvataggio...",
  "msg.save_success": "Salvato con successo",
  "msg.save_error": "Salvataggio fallito",
  "msg.error": "Errore",
  "msg.success": "Successo",
  "msg.no_data": "Nessun dato disponibile",

  // Form Labels
  "form.serial_number": "Numero di Serie",
  "form.unit_model": "Modello Unità",
  "form.production_line": "Linea di Produzione",
  "form.operator": "Operatore",
  "form.date": "Data",
  "form.time": "Ora",

  // Unit Details Form
  "unit.title": "Dettagli Unità",
  "unit.back": "Indietro",
  "unit.serial_number": "Numero di Serie",
  "unit.work_order": "Ordine di Lavoro",
  "unit.unit_model": "Modello Unità (Prodotto)",
  "unit.production_line": "Linea di Produzione - {0} disponibili",
  "unit.date_time": "Data e Ora",
  "unit.unit_lock": "Blocco Unità",
  "unit.locked": "Bloccato",
  "unit.unlocked": "Sbloccato",
  "unit.enter_serial": "Inserisci numero di serie manualmente",
  "unit.scan_serial": "Numero di serie da scanner",
  "unit.enter_work_order": "Inserisci ordine di lavoro",
  "unit.enter_unit_model": "Inserisci modello unità",
  "unit.select_production_line": "Seleziona linea di produzione",
  "unit.no_production_lines": "Nessuna linea di produzione disponibile",
  "unit.loading_production_lines": "Caricamento linee di produzione...",
  "unit.unit_is": "L'unità è {0}",
  "unit.continue": "Continua",

  // Category View Page
  "category.title": "Pagina Categorie",
  "category.audit_session": "Sessione Audit",
  "category.work_started": "Lavoro Iniziato",
  "category.product_serial": "Seriale Prodotto",
  "category.current_score": "Punteggio Attuale",
  "category.points": "punti",
  "category.form_details": "Dettagli Modulo",
  "category.start_complete_audit": "Inizia Audit Completo",
  "category.all_categories": "(Tutte le Categorie)",
  "category.select_individual": "Oppure seleziona singole categorie:",
  "category.loading_categories": "Caricamento categorie...",
  "category.error_loading_form": "Errore nel caricamento dati modulo",
  "category.no_categories": "Nessuna Categoria Disponibile",
  "category.no_categories_desc": "Nessuna categoria trovata per il modulo selezionato.",
  "category.control_items_completed": "Elementi di Controllo Completati",
  "category.form_name": "Nome Modulo",
  "category.form_code": "Codice Modulo",
  "category.italian_name": "Nome Italiano",
  "category.total_fields": "Campi Totali",
  "category.total_points": "Punti Totali",
  "category.passing_threshold": "Soglia di Superamento",
  "category.production_line": "Linea di Produzione",
  "category.line_name": "Nome Linea",
  "category.line_id": "ID Linea",
  "category.product": "Prodotto",
  "category.product_name": "Nome Prodotto",
  "category.model_number": "Numero Modello",
  "category.categories": "Categorie",
  "category.items": "Elementi",
  "category.status_dates": "Stato e Date",
  "category.created": "Creato",
  "category.loading_form_details": "Caricamento dettagli modulo...",
  "category.error_loading_details": "Errore nel caricamento dettagli modulo",
  "category.no_detailed_data": "Nessun dato dettagliato del modulo disponibile",

  // Checklist Page Loop
  "checklist.category_completed": "Categoria Completata",
  "checklist.completed": "✓ Completato",
  "checklist.next_category": "Prossima Categoria",
  "checklist.all_complete": "🎉 Tutte le Categorie Complete!",
  "checklist.categories_reviewed": "⚠️ Categorie Riviste",
  "checklist.ready_for_summary": "L'audit è pronto per il riepilogo",
  "checklist.items_need_completion": "{0} elemento{1} di controllo necessita{2} ancora completamento",
  "checklist.each_item_requirement": "Ogni elemento di controllo deve avere almeno un controllo marcato per essere considerato completo.",
  "checklist.progress": "Progresso",
  "checklist.of_categories": "di {0} categorie",
  "checklist.stay_here": "Rimani Qui",
  "checklist.continue": "Continua",
  "checklist.go_to_summary": "Vai al Riepilogo",
  "checklist.try_to_continue": "Prova a Continuare",
  "checklist.no_categories_available": "Nessuna Categoria Disponibile",
  "checklist.no_categories_found": "Nessuna categoria trovata per questo modulo di audit.",
  "checklist.no_control_items": "Nessun Elemento di Controllo",
  "checklist.no_control_items_found": "Nessun elemento di controllo trovato per la categoria corrente.",
  "checklist.next": "Avanti",
  "checklist.previous": "Indietro",
  "checklist.uploading_images": "Caricamento immagini...",
  "checklist.saving_progress": "Salvataggio progresso...",
  "checklist.image_uploads_disabled": "Caricamento immagini disabilitato",
  "checklist.saved_successfully": "Salvato con successo",
  "checklist.category": "Categoria",
  "checklist.score": "Punteggio",
  "checklist.control_items": "Elementi di Controllo",
  "checklist.categories": "Categorie",
  "checklist.dashboard": "Dashboard",
  "checklist.check_description": "Descrizione Controllo",
  "checklist.quantity": "Quantità",
  "checklist.pictures": "Immagini",
  "checklist.comment": "Commento",
  "checklist.fixed_before_shipment": "Risolto prima della Spedizione",
  "checklist.production_phase": "Fase di Produzione",
  "checklist.category_of": "Categoria {0} di {1}",
  "checklist.comment_for": "Commento per: {0}",
  "checklist.save_comment": "Salva Commento",
  "checklist.view_full_size": "Visualizza dimensione intera",
  "checklist.remove_image": "Rimuovi immagine",
  "checklist.add_picture": "Aggiungi Immagine",
  "checklist.add_comment": "Aggiungi Commento",
  "checklist.view_comment": "Visualizza Commento",
  "checklist.no_check_items": "Nessun Elemento da Controllare",
  "checklist.no_check_items_desc": "Questo elemento di controllo non ha elementi di controllo definiti.",
  "checklist.loading": "Caricamento...",
  "checklist.previous": "Precedente",
  "checklist.next": "Successivo",
  "checklist.saving": "Salvataggio...",
  "checklist.complete_required": "Completa Campi Obbligatori",
  "checklist.complete_tooltip": "Completa tutti i campi obbligatori: gli elementi del Gruppo B necessitano immagine + commento",
  "checklist.control_item_of": "Elemento di Controllo {0} di {1}",
  "checklist.images_for": "Immagini per: {0}",
  "checklist.images_count": "{0} immagine(i)",
  "checklist.no_images": "Nessuna immagine caricata ancora",
  "checklist.use_camera": "Usa l'icona della fotocamera per aggiungere immagini",
  "checklist.cloud_storage": "Immagini archiviate nel cloud",
  "checklist.cloud_not_configured": "Archiviazione cloud non configurata",
  "checklist.add_more_images": "Aggiungi Altre Immagini",
  "checklist.add_image": "Aggiungi Immagine",
  "checklist.choose_method": "Scegli come vuoi aggiungere un'immagine:",
  "checklist.take_photo": "Scatta Foto",
  "checklist.upload_file": "Carica File",
  "checklist.position_camera": "Posiziona la fotocamera e tocca il pulsante di cattura",
  "checklist.retake": "Riprendi",
  "checklist.save_image": "Salva Immagine",
  "checklist.compress_note": "L'immagine verrà compressa a meno di 200KB per un caricamento ottimale",
  "checklist.cancel": "Annulla",
  "checklist.clear": "Cancella",
  "checklist.enter_comment": "Inserisci il tuo commento...",
  "checklist.phase": "Fase",
  "checklist.phase_planning": "Pianificazione",
  "checklist.phase_development": "Sviluppo",
  "checklist.phase_testing": "Test",
  "checklist.phase_production": "Produzione",
  "checklist.phase_complete": "Completo",

  // Form Selection Page
  "forms.title": "Seleziona dai Moduli Disponibili",
  "forms.back": "Indietro",
  "forms.refresh": "Aggiorna",
  "forms.loading": "Caricamento...",
  "forms.loading_forms": "Caricamento moduli di audit...",
  "forms.loading_form": "Caricamento modulo...",
  "forms.no_forms_available": "Nessun Modulo Disponibile",
  "forms.no_forms_desc": "Nessun modulo di audit è attualmente disponibile per la selezione.",
  "forms.contact_admin": "Contatta il tuo amministratore o prova ad aggiornare la pagina.",
  "forms.retry": "Riprova",
  "forms.select_form": "Seleziona modulo {0}",
  "forms.code": "Codice",
  "forms.fields": "Campi",
  "forms.points": "Punti",
  "forms.line": "Linea",
  "forms.created": "Creato",

  // Audit Summary Page
  "summary.title": "Riepilogo Audit",
  "summary.review_before_submit": "Rivedi il tuo audit prima dell'invio finale",
  "summary.back_to_audit": "Torna all'Audit",
  "summary.submit_audit": "Invia Audit",
  "summary.submitting": "Invio in corso...",
  "summary.no_images": "Nessuna immagine",
  "summary.complete": "Completo",
  "summary.incomplete": "Incompleto",
  "summary.not_started": "Non Iniziato",
  "summary.edit": "Modifica",
  "summary.points": "pt",
  "summary.go_back": "Torna all'Audit",
  "summary.confirm_submission": "Sei sicuro di voler inviare questo audit?",
  "summary.no_changes_after": "Non potrai apportare modifiche dopo l'invio.",
  "summary.audit_summary_stats": "📊 Riepilogo Audit:",
  "summary.control_items_completed": "elementi di controllo completati",
  "summary.need_changes": "Devi apportare modifiche? Clicca **\"Torna all'Audit\"** per continuare a modificare.",
  "summary.ready_finalize": "Pronto per finalizzare? Clicca **\"Invia Audit\"** per completare il processo.",

  // Control Items View Page
  "control_items.title": "Elementi di Controllo",
  "control_items.back_to_categories": "Torna alle Categorie",
  "control_items.no_items": "Nessun Elemento di Controllo",
  "control_items.no_items_desc": "Nessun elemento di controllo trovato per questa categoria.",
  "control_items.loading": "Caricamento elementi di controllo...",
  "control_items.select_item": "Seleziona elemento di controllo",
  "control_items.completed": "Completato",
  "control_items.not_started": "Non Iniziato",
  "control_items.in_progress": "In Corso",
  "control_items.audit_session": "SESSIONE AUDIT",
  "control_items.work_started": "LAVORO INIZIATO",
  "control_items.product_serial": "SERIALE PRODOTTO",
  "control_items.current_score": "PUNTEGGIO ATTUALE",
  "control_items.points": "punti",
  "control_items.form_details": "Dettagli Modulo",
  "control_items.control_items_in": "Elementi di Controllo in",
  "control_items.continue_incomplete": "Continua con elemento incompleto sotto",
  "control_items.next_item": "Prossimo elemento:",
  "control_items.look_for": "Cerca",
  "control_items.continue_indicator": "Continua da qui",
  "control_items.category_completed": "Categoria completata!",
  "control_items.all_items_completed": "Tutti gli elementi di controllo in questa categoria sono stati completati. Puoi rivedere gli elementi completati o tornare alle categorie per continuare con altre categorie.",
  "control_items.loading_control_items": "Caricamento elementi di controllo...",
  "control_items.error_loading_form": "Errore nel caricamento dati modulo",
  "control_items.checks": "Controlli",
  "control_items.no_available": "Nessun Elemento di Controllo Disponibile",
  "control_items.no_found_category": "Nessun elemento di controllo trovato per la categoria selezionata.",
  "control_items.next": "Avanti",
  "control_items.details": "Dettagli",

  // Checklist Page
  "checklist_page.back": "Indietro",
  "checklist_page.next": "Avanti",
  "checklist_page.submit": "Invia",
  "checklist_page.save_draft": "Salva Bozza",
  "checklist_page.add_comment": "Aggiungi Commento",
  "checklist_page.take_photo": "Scatta Foto",
  "checklist_page.upload_image": "Carica Immagine",
  "checklist_page.comment_placeholder": "Aggiungi il tuo commento qui...",
  "checklist_page.required_for_defects": "Richiesto per difetti",
  "checklist_page.optional": "Opzionale",

  // Login Screen
  "login.title": "Accesso Operazioni QA",
  "login.welcome": "Benvenuto nelle Operazioni di Garanzia Qualità",
  "login.username": "Nome Utente",
  "login.password": "Password",
  "login.login_button": "Accedi",
  "login.logging_in": "Accesso in corso...",
  "login.enter_username": "Inserisci il tuo nome utente",
  "login.enter_password": "Inserisci la tua password",
  "login.invalid_credentials": "Credenziali non valide",
  "login.login_failed": "Accesso fallito",

  // Summary Item Page
  "summary_item.loading_form_details": "Caricamento dettagli modulo...",
  "summary_item.error_loading_details": "Errore nel caricamento dettagli modulo",
  "summary_item.no_detailed_data": "Nessun dato dettagliato del modulo disponibile",
  "summary_item.form_name": "Nome Modulo",
  "summary_item.form_code": "Codice Modulo",
  "summary_item.italian_name": "Nome Italiano",
  "summary_item.total_fields": "Campi Totali",
  "summary_item.total_points": "Punti Totali",
  "summary_item.passing_threshold": "Soglia di Superamento",
  "summary_item.loading_results": "Caricamento risultati audit...",
  "summary_item.error_loading_results": "Errore nel Caricamento Risultati",
  "summary_item.try_again": "Riprova",
  "summary_item.go_back_dashboard": "Torna alla Dashboard",
  "summary_item.audit_summary": "Riepilogo Audit",
  "summary_item.control_items_summary": "Riepilogo Elementi di Controllo Audit",
  "summary_item.status": "Stato",
  "summary_item.form_details": "Dettagli Modulo",
  "summary_item.audit_details": "Dettagli Audit",
  "summary_item.audit_form": "Modulo Audit",
  "summary_item.audit_session_id": "Audit Ref #",
  "summary_item.failed_control_items": "Elementi di Controllo Falliti",
  "summary_item.go_back_audit": "Torna all'audit",
  "summary_item.audit_completed": "Audit Completato",
  "summary_item.details": "Dettagli",
  "summary_item.result": "Risultato",
  "summary_item.submitted": "Inviato",
  "summary_item.unit_information": "Informazioni Unità",
  "summary_item.serial_number": "Numero di Serie",
  "summary_item.unit_model": "Modello Unità",
  "summary_item.date_time": "Data e Ora",
  "summary_item.work_order": "Ordine di Lavoro (OV)",
  "summary_item.production_line": "Linea di Produzione",
  "summary_item.unit_lock": "Blocco Unità",
  "summary_item.operator": "Operatore",
  "summary_item.form": "Modulo",
  "summary_item.final_score": "Punteggio Finale",
  "summary_item.max_points": "Punti Massimi -",
  "summary_item.passing_threshold_label": "Soglia di Superamento:",
  "summary_item.total_control_items": "Totale Elementi di Controllo:",
  "summary_item.passed_control_items": "Elementi di Controllo Superati:",
  "summary_item.critical_issues": "Problemi Critici:",
  "summary_item.na": "N/D",
  "summary_item.unknown_operator": "Operatore Sconosciuto",

  // Language Toggle
  "lang.english": "English",
  "lang.italian": "Italiano",
  "lang.switch_to": "Passa a {0}",

  // Additional Audit Summary translations
  "summary.close": "×",
  "summary.edit": "Modifica",
  "summary.attached_images": "Immagini Allegate",
  "summary.missing_required": "Mancanti richiesti:",
  "summary.image": "immagine",
  "summary.and": "e",
  "summary.comment": "commento",
  "summary.audit_information": "Informazioni Audit",
  "summary.progress_overview": "Panoramica Progresso",
  "summary.categories": "Categorie",
  "summary.control_items": "Elementi di Controllo",
  "summary.checks_selected": "Controlli Selezionati",
  "summary.images_uploaded": "Immagini Caricate",
  "summary.validation_status": "Stato Validazione",
  "summary.errors": "Errori:",
  "summary.warnings": "Avvertimenti:",
  "summary.ready_for_submission": "✓ L'audit è pronto per l'invio",
  "summary.detailed_review": "Revisione Dettagliata",
  "summary.review_categories_items": "Rivedi tutte le categorie e gli elementi di controllo. Clicca \"Modifica\" per apportare modifiche.",
  "summary.edit_category": "Modifica Categoria",
  "summary.no_control_items_found": "Nessun elemento di controllo trovato in questa categoria",
  "summary.irreversible_action": "Questa è un'azione irreversibile!",
  "summary.final_audit_submission": "Invio Finale Audit",
  "summary.cannot_make_changes": "Una volta inviato questo audit, non potrai apportare modifiche. Assicurati che tutte le informazioni siano accurate e complete.",
  "summary.audit_summary_stats": "📊 Riepilogo Audit:",
  "summary.control_items_completed": "elementi di controllo completati",
  "summary.check_items_selected": "elementi di controllo selezionati",
  "summary.images_uploaded_count": "immagini caricate",
  "summary.all_validations_passed": "Tutte le validazioni superate",
  "summary.need_changes": "Devi apportare modifiche? Clicca \"Torna all'Audit\" per continuare a modificare.",
  "summary.ready_finalize": "Pronto per finalizzare? Clicca \"Invia Audit\" per completare il processo.",
  "summary.no_audit_data": "Nessun Dato Audit Disponibile",
  "summary.complete_audit_items": "Completa alcuni elementi dell'audit prima di visualizzare il riepilogo.",
  "summary.id": "ID:",
  "summary.created": "Creato:",
  "summary.serial": "Seriale:",
  "summary.today": "Oggi",
  "summary.na": "N/D",

  // Validation and Toast Messages
  "summary.no_control_items_to_audit": "Nessun elemento di controllo trovato per l'audit",
  "summary.no_check_items_selected": "Nessun elemento di controllo è stato selezionato",
  "summary.score_calculation_incomplete": "Il calcolo del punteggio potrebbe non essere completo",
  "summary.cannot_submit_with_errors": "Impossibile inviare audit con errori di validazione. Rivedi e completa tutti i campi richiesti.",
  "summary.warnings_review_before_submit": "Ci sono alcuni avvertimenti. Rivedi prima di inviare.",
  "summary.audit_submitted_success": "Audit inviato con successo!",
  "summary.failed_to_submit": "Invio audit fallito. Riprova.",
  "summary.problems_only": "Solo Problemi",
  "summary.all_items": "Tutti gli Elementi",
  "summary.showing_problems_count": "Mostrando {0} elementi di controllo con problemi",
  "summary.items_with_no_problems": "elementi senza problemi sono nascosti",
  "summary.no_problems_detected": "Nessun Problema Rilevato!",
  "summary.all_control_items_passed": "Tutti gli elementi di controllo sono stati superati. Ottimo lavoro!",
  "summary.view_all_items": "Visualizza Tutti gli Elementi",
  "summary.category_deductions": "Deduzioni per Categoria",
  "summary.total_deductions": "Deduzioni Totali",
  "summary.total_score": "Punteggio Totale",
  "summary.completed": "Completato",
  "summary.ongoing": "In Corso",
  "summary.not_started": "Non Iniziato",
  "summary.total": "Totale",
};